import instObj from '@/backend/axios-instances'

const resource = "/ticketing/company"
const instance = instObj.baseInstance

export default {
  get(companyId) {
    return instance.get(`${resource}/${companyId}`);
  },
  delete(companyId) {
    return instance.delete(`${resource}/${companyId}`);
  },
  put(companyId, data) {
    return instance.put(`${resource}/${companyId}`, data);
  }
}
